import React, { useState } from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ProgramPricingInfo from "./ProgramPricingInfo";

function PravoMaster() {
  const [t] = useTranslation();

  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Pravo master" />
      <section className="project-detail">
        <div className="container">
          <div className="lower-content">
            <div className="row">
              <div className="text-column col-lg-9 col-md-9 col-sm-12">
                <h2>{t("masterp.title")}</h2>
                <div className="upper-box">
                  <div className="single-item-carousel owl-carousel owl-theme">
                    <figure className="image">
                      <img
                        src="assets/img/bg/Fpep-04.png"
                        alt="PravoMaster slika"
                      />
                    </figure>
                  </div>
                </div>
                <div className="inner-column textjustify">
                  <h3>{t("programi.subtitle1")}</h3>
                  <p>{t("masterp.opisprograma")}</p>
                  <h4>{t("programi.subtitle2")}</h4>
                  <p>{t("masterp.stacetenauciti")}</p>

                  <ul className="pr-ul">
                    <li>
                      <div className="icon">
                        <i className="fas fa-check" />
                      </div>
                      <div className="text">{t("programi.benefit1")}</div>
                    </li>
                    <li>
                      <div className="icon">
                        <i className="fas fa-check" />
                      </div>
                      <div className="text">{t("programi.benefit2")}</div>
                    </li>
                    <li>
                      <div className="icon">
                        <i className="fas fa-check" />
                      </div>
                      <div className="text">{t("programi.benefit3")}</div>
                    </li>
                    <li>
                      <div className="icon">
                        <i className="fas fa-check" />
                      </div>
                      <div className="text">{t("programi.benefit4")}</div>
                    </li>
                  </ul>

                  <h3>{t("programi.sadrzajPredmeta")}</h3>

                  <div
                    className="faq-wrap faq-wrap2 pt-30 wow fadeInUp animated"
                    data-animation="fadeInUp"
                    data-delay=".4s"
                  >
                    <div className="accordion" id="accordionExample">
                      <div className="card">
                        <div className="card-header" id="headingThree">
                          <h2 className="mb-0">
                            <button
                              className={`faq-btn${
                                activeIndex === 0 ? "" : " collapsed"
                              }`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse0"
                              onClick={() => handleToggle(0)}
                            >
                              {t("programi.prvaGodina")}
                              <span>{t("programi.listaPredmeta")}</span>
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapse0"
                          className={`collapse${
                            activeIndex === 0 ? " show" : ""
                          }`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="card-body">
                            <div className="leactures">
                              <ul>
                                <li>
                                  <Link to="/metodologija-naucno-istrazivackog-rada-pm">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.mp1")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/pravno-normiranje-pm">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.mp2")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/organizacija-pravosudja-pm">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.mp3")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/finansijsko-pravo-pm">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.mp4")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/medjunarodno-krivicno-pravo-pm">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.mp5")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/medjunarodno-gradjansko-procesno-pravo-pm">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.mp6")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/pravo-intelektualne-svojine-pm">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.mp7")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/medjunarodno-privredno-pravo-pm">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("prvagodina.mp8")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card">
                        <div className="card-header" id="headingOne">
                          <h2 className="mb-0">
                            <button
                              className={`faq-btn${
                                activeIndex === 1 ? "" : " collapsed"
                              }`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse1"
                              onClick={() => handleToggle(1)}
                            >
                              {t("programi.drugaGodina")}
                              <span>{t("programi.listaPredmeta")}</span>
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapse1"
                          className={`collapse${
                            activeIndex === 1 ? " show" : ""
                          }`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="card-body">
                            <div className="leactures">
                              <ul>
                                <li>
                                  <Link to="/ugovorno-pravo-pm">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.mp1")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/arbitrazno-pravo-pm">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.mp2")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/medjunarodne-organizacije-pm">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugagodina.mp3")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("programi.izborni1")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("programi.istrazivacki")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link>
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("programi.masterrad")}
                                    </div>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card">
                        <div className="card-header" id="headingFour">
                          <h2 className="mb-0">
                            <button
                              className={`faq-btn${
                                activeIndex === 2 ? "" : " collapsed"
                              }`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse2"
                              onClick={() => handleToggle(2)}
                            >
                              {t("programi.drugaIzborna")}
                              <span>{t("programi.listaPredmeta")}</span>
                            </button>
                          </h2>
                        </div>
                        <div
                          id="collapse2"
                          className={`collapse${
                            activeIndex === 2 ? " show" : ""
                          }`}
                          data-bs-parent="#accordionExample"
                        >
                          <div className="card-body">
                            <div className="leactures">
                              <ul>
                                <li>
                                  <Link to="/korporativno-upravljanje-pm">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugaizborna.mp1")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/maloljetnicko-krivicno-pravo-pm">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugaizborna.mp2")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/vanparnicni-i-izvrsni-postupak-pm">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugaizborna.mp3")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                                <li>
                                  <Link to="/diplomatsko-i-konzularno-pravo-pm">
                                    <div className="text">
                                      <i className="fas fa-book" />{" "}
                                      {t("drugaizborna.mp4")}
                                    </div>
                                    <div className="time">
                                      <i className="fas fa-arrow-right" />{" "}
                                      {t("programi.detaljnije")}
                                    </div>
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <aside className="sidebar-widget info-column">
                  <div className="inner-column3">
                    <h3>{t("programi.osnovneinfo")}</h3>
                    <ul className="project-info clearfix">
                      <li>
                        <ProgramPricingInfo level="master" t={t} />
                      </li>
                      <li>
                        <span className="icon fas fa-university" />{" "}
                        <strong>{t("programi.tipstudija")}</strong>{" "}
                        <span>{t("programi.akademske")}</span>
                      </li>
                      <li>
                        <span className="icon fas fa-calendar-alt" />{" "}
                        <strong>{t("programi.stepenstudija")}</strong>{" "}
                        <span>{t("programi.stepenmaster")}</span>
                      </li>

                      <li>
                        <span className="icon fas fa-clock" />{" "}
                        <strong>{t("programi.trajanje")} </strong>{" "}
                        <span>{t("programi.trajanje2")}</span>
                      </li>
                      <li>
                        <span className="icon fas fa-graduation-cap" />{" "}
                        <strong>{t("programi.zvanje")}</strong>{" "}
                        <span>{t("masterp.zvanje")}</span>
                      </li>
                      <li>
                        <div className="slider-btn">
                          <a
                            href="https://docs.google.com/forms/d/e/1FAIpQLSejqXir_pUuSCp0MwDJLzLoTDiT2SphgLQPO8_-5t35dxh5lw/viewform"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn ss-btn smoth-scroll"
                          >
                            {t("programi.apply")}{" "}
                            <i className="fas fa-arrow-right" />
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default PravoMaster;
